export default __webpack_public_path__ + "static/media/kiki.2043c8fc.gif";